import { ButtonText, Flex, Typography } from '@percent/lemonade'
import { SidePanelProps } from './side-panel.types'
import cn from 'classnames'
import { FlexProps } from '../flex/flex.types'

import styles from './side-panel.module.scss'

function SidePanelFooter({
  children,
  className,
  ...props
}: Readonly<FlexProps>) {
  return (
    <Flex {...props} className={cn(className, styles.footer)}>
      {children}
    </Flex>
  )
}

export function SidePanel({
  title,
  onClose,
  children,
  testId,
  closeButtonTestId,
  ...props
}: Readonly<SidePanelProps>) {
  return (
    <Flex
      {...props}
      data-testid={testId}
      className={cn(props.className, styles.sidePanel)}
    >
      <Flex className={styles.header}>
        <Typography variant="h3">{title}</Typography>
        <ButtonText
          icon="close"
          onClick={onClose}
          data-testid={closeButtonTestId}
        />
      </Flex>
      {children}
    </Flex>
  )
}

SidePanel.Footer = SidePanelFooter
